// Difficulty profiles. CRITICAL INVARIANT: 'normal' is the identity
// profile (every multiplier is 1, debtGameOverDays is the base 14) and is
// the default in the store's initialState. Because every test runs through
// resetStore() (-> difficulty 'normal'), the deterministic numeric tests
// stay green. Never give 'normal' a non-identity value.

import { useGameStore } from '@/store/gameStore'

export type Difficulty = 'easy' | 'normal' | 'hard'

export interface DifficultyModifiers {
  incomeMultiplier: number
  expenseMultiplier: number
  demandMultiplier: number
  debtGameOverDays: number
  prizeMultiplier: number
  /** How much the board forgives a failed objective (1 = neutral, >1 lenient) */
  boardLeniency: number
  /** Applied only when starting a new game */
  startingMoneyMultiplier: number
}

export const DIFFICULTY_CONFIG: Record<Difficulty, DifficultyModifiers> = {
  easy: {
    incomeMultiplier: 1.3,
    expenseMultiplier: 0.7,
    demandMultiplier: 1.2,
    debtGameOverDays: 21,
    prizeMultiplier: 1.3,
    boardLeniency: 1.5,
    startingMoneyMultiplier: 1.5,
  },
  normal: {
    incomeMultiplier: 1,
    expenseMultiplier: 1,
    demandMultiplier: 1,
    debtGameOverDays: 14,
    prizeMultiplier: 1,
    boardLeniency: 1,
    startingMoneyMultiplier: 1,
  },
  hard: {
    incomeMultiplier: 0.7,
    expenseMultiplier: 1.4,
    demandMultiplier: 0.78,
    debtGameOverDays: 9,
    prizeMultiplier: 0.7,
    boardLeniency: 0.7,
    startingMoneyMultiplier: 0.6,
  },
}

export const DEFAULT_DIFFICULTY: Difficulty = 'normal'

export const DIFFICULTY_LABELS: Record<Difficulty, string> = {
  easy: 'Fácil',
  normal: 'Normal',
  hard: 'Difícil',
}

/** Modifiers for the difficulty currently set in the store (default normal) */
export function getDifficultyMods(): DifficultyModifiers {
  const d = useGameStore.getState().difficulty ?? DEFAULT_DIFFICULTY
  return DIFFICULTY_CONFIG[d]
}
